import isGHMC, { formattedDate, formattedDateTypeTwo, getCurrentDate, getFirstDateOfMonth, formatDateTimeWithoutSec } from "../../../../Common/helper/helpar";
import Modal from "react-bootstrap/Modal";
import { MonthWiseAttendanceFilters } from "./MonthWiseAttendanceFilters";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  TablePagination,
  Paper,
} from "@mui/material";
import {
  useMonthWiseAttendanceStore,
} from "./MonthWiseAttendanceStore";
import { useEffect, useState } from "react";
import Loader from "../../../../Common/Loader/loader";
import { Button } from "react-bootstrap";
import { bouncy } from "ldrs";
import TableSkeleton from "../../../AllotedMaster/TableSkeleton";
bouncy.register()


const MonthWiseAttendanceSummary = () => {
  const { MonthWiseAttendanceData, isLoading, fetchMonthWiseAttendanceReport, updateEmployeeAttendanceStatus, isUpdating } =
    useMonthWiseAttendanceStore();
  const [days, setDays] = useState([]);
  const [lgShow, setLgShow] = useState(false);
  const [formModal, setFormModal] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [errors, setErrors] = useState({});
  const [dayWiseAttendance, setDayWiseAttendance] = useState(null);
  const currentDate = getCurrentDate();
  const [formSubmitted, setFormSubmitted] = useState(false);

  const [formData, setFormData] = useState({
    employeeId: "", // Set employee ID dynamically
    attendanceDate: "",
    attendanceStatus: "",
    punchInTime: "",
    punchOutTime: "",
    comment:"",
    description: "",
    FromDate: "",
    ToDate: "",
  });

  const formatDateTime = (date) => {
    if (!date) return "";
    return new Date(date).toISOString().slice(0, 16);
  };

  useEffect(() => {
    if (dayWiseAttendance) {
      setFormData((prev) => ({
        ...prev,
        // punchInTime: formatDateTime(dayWiseAttendance),
      }));
    }
  }, [dayWiseAttendance]);

  useEffect(() => {
    if (MonthWiseAttendanceData[0]?.dayWiseAttendance) {
      const getMonth = JSON?.parse(
        MonthWiseAttendanceData[0]?.dayWiseAttendance
      );
      setDays(getMonth);
    } else {
      setDays([]);
    }
  }, [MonthWiseAttendanceData, MonthWiseAttendanceData[0]?.dayWiseAttendance]);

  const handleAttendanceClick = (employeeId, attendanceStatus) => {
    setFormData((prevData) => ({
      ...prevData,
      employeeId, // Set selected employee ID

    }));
    setLgShow(true);
  };
  const handleYesClick = () => {
    setLgShow(false); // Close the first modal
    setFormModal(true);
  };
  const handlePunchInChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
      punchOutTime: "", // Reset punchOutTime when punchInTime changes
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: value ? "" : prevErrors[name],
      punchOutTime: "", // Clear punchOutTime error when punchInTime is updated
    }));
  };
  const handleChange = (e) => {
    const { name, value } = e.target;

    // Prevent selecting punchOutTime before punchInTime
    if (name === "punchOutTime" && value < formData.punchInTime) {
      return;
    }

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: value ? "" : prevErrors[name],
    }));
  };

  const handleClose = () => {
    setLgShow(false); // Close the large modal
    setFormModal(false); // Close the form modal
    setFormSubmitted(false); // Reset form submission state
    setErrors({}); // Clear validation errors
    setFormData({
      attendanceStatus: "",
      description: "",
      comment:"",
      punchInTime: "",
      punchOutTime: "",
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent form default submission
    setFormSubmitted(true);
    let validationErrors = {};
    if (!formData.attendanceStatus) {
      validationErrors.attendanceStatus = "Current Status is required";
    }
    if (!formData.punchInTime) {
      validationErrors.punchInTime = "Punch In Time is required";
    }

    // If there are errors, update state and stop submission
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    // Reset errors if form is valid
    setErrors({});

    const formatTimeToISO = (dateTime) => {
      if (!dateTime) return null; // Handle empty values
      return new Date(dateTime).toISOString();
    };
    const payload = {
      ...formData,
      attendanceDate: formatTimeToISO(dayWiseAttendance),
      punchInTime: formData.punchInTime,
      punchOutTime: formData.punchOutTime ? formData.punchOutTime : null,
    };
    const getLast30DaysDate = (day) => {
      const toDate = new Date(day);
      const thirtyDaysAgo = new Date(toDate.setDate(toDate.getDate() - 30));
      return thirtyDaysAgo.toISOString().split("T")[0]; // Format the date as YYYY-MM-DD
    };
    const today = new Date();
    const queryString = {
      FromDate: getFirstDateOfMonth(),
      ToDate: currentDate,
    };
    try {
      const response = await updateEmployeeAttendanceStatus(payload);
      console.log("Success:", response);
      setFormData({
        attendanceStatus: "",
        description: "",
        punchInTime: "",
        punchOutTime: "",
      });
      setErrors({});
      setFormModal(false); // Close edit modal
      setShowConfirmationModal(true); // Show confirmation modal
      handleClose();
      fetchMonthWiseAttendanceReport(queryString);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const isProd = isGHMC();
  const headerStyles = {
    textAlign: "center",
    border: "1px solid #ddd",
    borderRight: "none",
    padding: "10px",
    color: "#fff",
    backgroundColor: isProd ? "#0d5da5" : "#EC1117",
  };
  const cellStyles = {
    textAlign: "center",
    border: "1px solid #ddd",
    borderRight: "none",
    padding: "10px",
    whiteSpace: "normal",
  };

  return (
    <>
      
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <h4 class="text-start mb-3">Month Wise Attendance Summary</h4>
            <div className="page-header text-start">
              <div className="card">
                <div className="card-body">
                  <MonthWiseAttendanceFilters />
                  {isLoading ? <TableSkeleton /> : (
                    <Paper>
                      <TableContainer
                        component={Paper}
                        sx={{
                          width: "100%",
                          border: "1px solid #ccc",
                        maxHeight: 560
                      }}
                    >
                      <Table stickyHeader>
                        <TableHead
                          className={`${isProd ? "bg-ghmc" : "bg-swm"}`}
                          style={{position: "sticky", top: 0}}
                        >
                          <TableRow>
                            <TableCell rowSpan={2} sx={headerStyles}>
                              S.No
                            </TableCell>
                            <TableCell rowSpan={2} sx={headerStyles}>
                              EMP ID
                            </TableCell>
                            <TableCell rowSpan={2} sx={headerStyles}>
                              Name
                            </TableCell>
                            <TableCell rowSpan={2} sx={headerStyles}>
  Corporation
</TableCell>
                            <TableCell
                              rowSpan={2}
                              style={{ minWidth: 120 }}
                              sx={headerStyles}
                            >
                              Operation
                            </TableCell>
                            <TableCell rowSpan={2} sx={headerStyles}>
                              Designation
                            </TableCell>
                            <TableCell rowSpan={2} sx={headerStyles}>
                              Transfer Station
                            </TableCell>
                            <TableCell
                              style={{ textAlign: "left" }}
                              colSpan={days.length}
                              sx={headerStyles}
                            >
                              <span
                                style={{ position: "sticky", top: 0, left: 20 }}
                              >
                                Day Wise Attendance
                              </span>
                            </TableCell>
                            <TableCell rowSpan={2} sx={headerStyles}>
                              Present Days
                            </TableCell>
                            <TableCell rowSpan={2} sx={headerStyles}>
                              Absent Days
                            </TableCell>
                            <TableCell rowSpan={2} sx={headerStyles}>
                              Forced Attendance (Present Days)
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            {days?.map((item, index) => {
                              return (
                                <TableCell
                                  key={index}
                                  rowSpan={2}
                                  sx={headerStyles}
                                >
                                  {formattedDate(item?.Date)}
                                </TableCell>
                              );
                            })}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {MonthWiseAttendanceData?.map((item, index) => {
                            return (
                              <TableRow
                                key={index}
                                sx={{
                                  backgroundColor: isProd
                                    ? index % 2 === 0
                                      ? "#8fc9ff"
                                      : "#aed8ff"
                                    : index % 2 === 0
                                      ? "#F8CCCD"
                                      : "#ffeded",
                                }}
                              >
                                <TableCell sx={cellStyles}>
                                  {index + 1}
                                </TableCell>
                                <TableCell sx={cellStyles}>
                                  {item.employeeId}
                                </TableCell>
                                <TableCell sx={cellStyles}>
                                  {item.name}
                                </TableCell>
                                <TableCell sx={cellStyles}>
  {item.corporationName || item.CorporationName || "N/A"}
</TableCell>
                                <TableCell sx={cellStyles}>
                                  {item.operation}
                                </TableCell>
                                <TableCell sx={cellStyles}>
                                  {item.designation}
                                </TableCell>
                                <TableCell sx={cellStyles}>
                                  {item.transferStationName}
                                </TableCell>
                                {JSON?.parse(item?.dayWiseAttendance)?.map((attendance, index) => {
                                  const today = currentDate == attendance.Date;
                                  return (
                                    <TableCell key={index} sx={cellStyles}>
                                      <a 
                                        className={`${today ? "text-black text-decoration-none" : ""} ${attendance?.Status === "Forced Attendance" ? "bg-white" : ""} `}
                                        href="#"
                                        onClick={(e) => {
                                          setDayWiseAttendance(attendance?.Date);
                                          if (
                                            ["Present", "Forced Attendance", "WeekOff", "N/A"].includes(
                                              attendance?.Status
                                            ) || today
                                          ) {
                                            e.preventDefault(); // Disable click
                                            return;
                                          }
                                          e.preventDefault();
                                          handleAttendanceClick(item?.employeeId, attendance?.Status);
                                        }}
                                        style={{
                                          display: "inline-block",
                                          textDecoration:
                                            ["Present", "Forced Attendance", "WeekOff", "N/A"].includes(
                                              attendance?.Status
                                            ) 
                                              ? "none"
                                              : "underline",
                                          color:
                                            ["Present", "Forced Attendance"].includes(
                                              attendance?.Status
                                            )
                                              ? "red"
                                              : attendance?.Status == "Absent" ? "blue" : "black",
                                          boxShadow:
                                            ["Present", "Forced Attendance"].includes(
                                              attendance?.Status
                                            )
                                              ? "0px 2px 5px rgba(0, 0, 0, 0.2)"
                                              : " ",
                                          padding:
                                            ["Present", "Forced Attendance", "WeekOff"].includes(
                                              attendance?.Status
                                            )
                                              ? "3px 7px"
                                              : "0px",
                                          cursor:
                                            ["Present", "Forced Attendance", "WeekOff", "N/A"].includes(
                                              attendance?.Status
                                            ) || today
                                              ? "not-allowed"
                                              : "pointer",
                                        }}
                                      >
                                      <span>
                                      {(attendance?.Status === "Present" || attendance?.Status === "Forced Attendance"
                                        ? "P"
                                        : attendance?.Status === "WeekOff"
                                          ? "WO"
                                          : attendance?.Status === "N/A"
                                            ? "N/A"
                                            : "A")}

                                    </span>
                                      </a>
                                      <span className="mt-1 d-block text-danger small">
                                        {attendance?.IsForced && attendance?.UpdatedName ? ` ${attendance.UpdatedName} -` : "" }
                                        {attendance?.IsForced && attendance?.UpdatedAt ? ` (${formatDateTimeWithoutSec(attendance.UpdatedAt)})` : "" }
                                      </span>
                                    </TableCell>
                                  );
                                })}

                                <TableCell sx={cellStyles}>
                                  {item.presentDays}
                                </TableCell>
                                <TableCell sx={cellStyles}>
                                  {item.absentDays}
                                </TableCell>
                                <TableCell sx={cellStyles}>
                                  {item.forcedAttendanceDays}
                                </TableCell>
                              </TableRow>
                            );
                          })}
                          {MonthWiseAttendanceData.length < 1 && (
                            <TableRow>
                              <TableCell colSpan={12} sx={cellStyles}>
                                No Data Available
                              </TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    {/* {rows?.length > defaultRowsPerPage && <TablePagination
                      rowsPerPageOptions={[5, 10, 25]}
                      component="div"
                      count={rows?.length}
                      rowsPerPage={rowsPerPage}
                      page={currentPage}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    />} */}
                  </Paper>)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <Button onClick={() => handleAttendanceClick("Present")}>
          Open Modal
        </Button>
      </div>
      <Modal show={lgShow} backdrop="static">
        <Modal.Header>
          <Modal.Title>Change Attendance Status</Modal.Title>
          <i
            className="fa-solid fa-xmark close-container"
            onClick={() => setLgShow(false)}
          ></i>
        </Modal.Header>
        <hr />
        <Modal.Body>
          <p className="mx-5">Would you like to change your attendance status?</p>
          <div className="d-flex justify-content-center gap-3 mt-4 mr-5 pb-4">
            <Button
              style={{
                width: "120px",
                backgroundColor: "#ec1117",
                color: "white",
                border: "none",
              }}
              onClick={() => setLgShow(false)}
            >
              No
            </Button>
            <Button
              variant="success"
              type="submit"
              style={{ width: "120px" }}
              onClick={handleYesClick}
            >
              Yes
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal show={formModal} backdrop="static">
        <Modal.Header>
          <Modal.Title>Change Attendance Status</Modal.Title>
          <i
            className="fa-solid fa-xmark close-container"
            onClick={handleClose}
          ></i>
        </Modal.Header>
        <hr />
        <Modal.Body>
          <form>
            <div className="row">
              <div className="col-md-6 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    Current Status<span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <select
                    className="form-select"
                    name="attendanceStatus"
                    value={formData.attendanceStatus}
                    onChange={handleChange}
                  >
                    <option value="">Select Status</option>
                    <option value="present">Present</option>
                  </select>
                  {errors.attendanceStatus && (
                    <p className="required-message">
                      {errors.attendanceStatus}
                    </p>
                  )}
                </div>
              </div>
              {/* <div className="col-md-6 mb-3">
                <div className="form-group">
                  <label className="form-label">Reason (Optional)</label>
                  <input
                    type="text"
                    className="form-control"
                    name="description"
                    placeholder="Enter Reason"
                    maxLength={42}
                    value={formData.description}
                    onChange={handleChange}
                  />
                </div>
              </div> */}
              <div className="col-md-6 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    Punch In Date and Time<span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <input
                    type="datetime-local"
                    className="form-control"
                    name="punchInTime"
                    value={formData.punchInTime}
                    onChange={handlePunchInChange}
                    max={new Date(dayWiseAttendance).toISOString().split("T")[0] + "T23:59"}  // Restrict selection to today
                    min={formatDateTime(dayWiseAttendance)}
                  />
                  {errors.punchInTime && (
                    <p className="required-message">{errors.punchInTime}</p>
                  )}
                </div>
              </div>
              <div className="col-md-6 mb-3">
                <div className="form-group">
                  <label className="form-label">Punch Out Date and Time</label>
                  <input
                    type="datetime-local"
                    className="form-control"
                    name="punchOutTime"
                    value={formData.punchOutTime}
                    onChange={handleChange}
                    max={new Date(dayWiseAttendance).toISOString().split("T")[0] + "T23:59"}
                    min={formData.punchInTime ? formatDateTime(formData.punchInTime) : formatDateTime(dayWiseAttendance)}
                    disabled={!formData.punchInTime}
                  />
                </div>
              </div>
              <div className="col-md-6 mb-3">
                <div className="form-group">
                  <label className="form-label">Comment</label>
                  <input
                    type="text"
                    className="form-control"
                    name="comment"
                    placeholder="Enter Comment "
                    maxLength={42}
                    value={formData.comment}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer d-flex justify-content-center">
              <button type="submit" className="deployment-button"
                onClick={handleSubmit}>
                {isUpdating ? <l-bouncy
                  size="25"
                  speed="1.75"
                  color="white"
                ></l-bouncy> : <> <i className="fa-solid fa-check done-container"></i> Save </>}
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
      <Modal show={showConfirmationModal} backdrop="static">
        <Modal.Header>
          <i
            className="fa-solid fa-xmark close-container"
            onClick={() => setShowConfirmationModal(false)}
          ></i>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex flex-column align-items-center text-center ">
            <i
              class="fa-regular fa-circle-check"
              style={{
                color: "#22cf5d",
                fontSize: "60px",
                marginBottom: "14px",
              }}
            ></i>
            <p style={{ color: "#1FBF55", fontSize: "18px" }}>
              Forced Attendance has been marked successfully
            </p>
            <p>
              Date of Change :{" "}
              <strong>{dayWiseAttendance && formattedDateTypeTwo(dayWiseAttendance)}</strong>{" "}
            </p>
            <p>
              Old Status : <strong>Absent</strong>
            </p>
            <p>
              New Status (Updated) : <strong>Present</strong>
            </p>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default MonthWiseAttendanceSummary;
